import type { RouteRecordRaw } from 'vue-router'
import CreateCreditNotePage from '@/views/billing/credit-notes/CreateCreditNote.vue'
import EditCreditNotePage from '@/views/billing/credit-notes/EditCreditNote.vue'
import { CreditNotesRouteNames } from '@/features/credit-notes/constants'

export default [
  { path: '/credit-notes/new', name: CreditNotesRouteNames.create, component: CreateCreditNotePage, meta: { pageTitle: 'Asset Credit note' } },
  { path: '/credit-notes/:id', name: CreditNotesRouteNames.edit, component: EditCreditNotePage, meta: { pageTitle: 'Asset Credit note' } },
] as RouteRecordRaw[]
